import { debounce } from '../components/utilities/behavior-helpers/index.js';
import { isSafari } from '../components/utilities/dom-helpers/index.js';

const setScrollPadding = () => {
    const SAFARI_SCROLL_OFFSET = 30;
    const header = document.querySelector('main-nav');
    if (!header)
        return;
    const headerShadowRootEl = header.shadowRoot.querySelector('nav');
    document.querySelector('html').style.scrollPaddingTop = `${headerShadowRootEl.clientHeight + (isSafari ? SAFARI_SCROLL_OFFSET : 0)}px`;
};
document.addEventListener('DOMContentLoaded', setScrollPadding);
window.addEventListener('resize', debounce(() => {
    setScrollPadding();
}, 100));

export { setScrollPadding };
